import { render, staticRenderFns } from "./introduceUnit.vue?vue&type=template&id=1d90bf79&scoped=true"
import script from "./introduceUnit.vue?vue&type=script&lang=js"
export * from "./introduceUnit.vue?vue&type=script&lang=js"
import style0 from "./introduceUnit.vue?vue&type=style&index=0&id=1d90bf79&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d90bf79",
  null
  
)

export default component.exports